import { userSelector } from 'scripts/redux/actions/user';
import { isLoggedIn } from 'src/utils/user';
import { loginUrl } from 'src/utils/pageUrls';
import {
  getDefaultAuthenticatedPath,
  isUserLoggedIn,
} from 'scripts/utilities/userAccountHelper';

export const requireUserLoginInterceptor = (store, nextState, replaceState) => {
  const { user } = userSelector(store.getState());

  if (!isLoggedIn(user)) {
    replaceState({
      pathname: loginUrl(),
      state: { nextPathname: nextState.location.pathname },
    });
    return true;
  }

  return false;
};

export const requireUserLogoutInterceptor = (
  store,
  nextState,
  replaceState,
) => {
  const { user } = userSelector(store.getState());

  if (isUserLoggedIn(user)) {
    replaceState({
      pathname: getDefaultAuthenticatedPath(user),
      state: { nextPathname: nextState.location.pathname },
    });
    return true;
  }

  return false;
};
